<button 
  [ngClass]="{
    'tab-button': true,
    'tab-button--selected': isSelected,
    'typography--text': true,
    'typography--text--size--medium': true,
    'typography--weight--regular': !isSelected,
    'typography--weight--bold': isSelected,
  }"
  (mousedown)="onClick($event)"
  (touchstart)="onClick($event)"
  [style.text-transform]="themeService.buttonConfig().textTransform"
>
  {{ label }}
</button>

